
import { MeRepository, LicensesRepository, ActivationCodesRepository } from 'common/repositories/index';

const _serviceDependencies = ['$scope', '$filter', '$rootScope'];

class Homepage {

    constructor($scope, $filter, $rootScope) {

        const user = MeRepository.getMyUser();
        $scope.filterName = $filter('friendName')(user);
        const date = new Date();

        $scope.todayDate = moment(date).format('L');

        const onLicensesNext = (data) => {

            $scope.numberOfLicenses = data.length;

        };

        this.licensesRepository = LicensesRepository.getObservable();
        this.licensesSubscriber = this.licensesRepository
            .subscribe(
                data => onLicensesNext(data),
                () => { },
                () => { },
            );

        const onActivationCodesNext = (data) => {

            // Hide subscriptions widget from homepage
            if (data.length) {

                $rootScope.hasSubscriptionOff = !$rootScope.cmaGBapplies ?
                    data.find(activationCode => activationCode.attributes.subscription === 0) :
                    false;

                if (!$rootScope.cmaGBapplies && !$rootScope.hasSubscriptionOff) {

                    $rootScope.hideHomepageSubscriptionWidget = true;

                } else {

                    $rootScope.hideHomepageSubscriptionWidget = false;

                }

            }

        };

        this.activationCodesRepository = ActivationCodesRepository.getObservable();
        this.activationCodesSubscriber = this.activationCodesRepository
            .subscribe(
                data => onActivationCodesNext(data),
                () => { },
                () => { },
            );

        if (!$rootScope.hasUsCompliance) {

            $rootScope.showCmaDisclaimer.banner = false;

        }

    }

}

_serviceDependencies.push(Homepage);

angular.module('controllers')
    .controller('Homepage', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/homepage/homepage.js